export const lineClamp = (lines: number): React.CSSProperties => ({
  display: "-webkit-box",
  whiteSpace: "normal",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitLineClamp: `${lines}`,
  lineClamp: `${lines}`,
});
